import {
  IsBoolean,
  IsOptional,
  IsUUID,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateLessonTeachingDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de la leçon' })
  @IsOptional()
  @IsUUID('4')
  lessonId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID du chapitre' })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({ type: 'string', description: "ID de l'enseignement" })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Visibilité de la leçon' })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean

  @ApiPropertyOptional({ type: 'string', description: 'ID du statut' })
  @IsOptional()
  @IsUUID('4')
  statusId?: string
}
